import { render, staticRenderFns } from "./VideoPublisherReprocess.vue?vue&type=template&id=096c8e1c&"
import script from "./VideoPublisherReprocess.vue?vue&type=script&lang=js&"
export * from "./VideoPublisherReprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports